import { Adapter } from './adapter';
import { StaticPage } from '@app/models/_index';
import { StaticPageInterface } from '@app/interfaces/_index';

/**
 * Adapts raw static pages object to a Static Page Model
 * NOTE: The item fields are the default json property names.
 */
export class StaticPageAdapter implements Adapter<StaticPage> {
  /**
   * Adapt data item into a StaticPage model.
   * @param item - data item StaticPage Interface to be transformed
   * @returns - returns an adapted StaticPage model
   */
  adapt(item: StaticPageInterface): StaticPage {
    let staticPage: StaticPage;

    if (item) {
      staticPage = new StaticPage(
        item.id,
        item.title.rendered,
        item.content.rendered,
        item.slug,
        item.acf,
        item.parent
      );
    }
    return staticPage;
  }
}
